import React from 'react';
import { StyleSheet, FlatList, View } from 'react-native';
import { Layout, Text, Icon, Button, useTheme } from '../../components/_primatives';
import { useQuery } from '@apollo/react-hooks';
import { Q_GET_SURVEY } from '../../data/api/query/q_survey';
import { CardItem } from '../../components/list-items/CardItem';
import { AuthContext } from '../../App';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions } from '../../utils/useScreenInfo';
import { NoSurveyCard } from '../../components/surveys/NoSurveyCard';
import { BASE_TYPES } from '../../data/models/enums/base_types';
import { Card, BasicCard } from '../../components/_primatives';




export function PollListScreen({ navigation }): React.ReactElement {
    const { pageSpacerHorizontal, bodyWidth, isMediumScreenOrLarger  } = useScreenDimensions();
    const theme = useTheme();
    const MAIN_COLOR: string = theme['color-primary-default'];
    const { user } = React.useContext(AuthContext);
    const { loading, error, data, refetch } = useQuery(Q_GET_SURVEY, {
        variables: { author_id: user.id, base_type: BASE_TYPES.POLL },
        fetchPolicy: 'network-only'
    });
    React.useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            // The screen is focused
            console.log('const unsubscribe = navigation.addListener(focus, () => refetch();')
            refetch();
        });

        // Return the function to unsubscribe from the event so it gets removed on unmount
        return unsubscribe;
    }, [navigation]);

    if (loading) return <PageLoadingIndicator />;
    if (error) {
        console.log('useQuery', error);
        return <Text>Error :(</Text>
    };
    console.log('we have data, ', data)

    const renderHeader = () => (
        <View style={{ marginVertical: 20, marginBottom: 30, paddingHorizontal: isMediumScreenOrLarger ? 0 : 23 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap' }}>
                <View>
                    <Text category='h1'>{'Polls'}</Text>
                    <View style={{ width: 90, backgroundColor: MAIN_COLOR, height: 4 }}></View>
                </View>
                <Button
                    onPress={() => navigation.navigate('CreatePoll')}
                    icon={(style) => <Icon {...style} name='plus' />}
                >
                    {isMediumScreenOrLarger ? `Create ` : ''}
                </Button>
            </View>
        </View>
    );
    const renderFooter = () => (
        <View style={{ height: 100 }}>
        </View>
    );
    const renderSurvey = ({ item }) => (
        <BasicCard onPress={() => navigation.navigate('Poll', { id: item.id })} style={isMediumScreenOrLarger ? { marginBottom: 15 } : { borderWidth: 0 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', }}>
                <Icon name={'bar-chart-outline'} style={{ marginRight: 20 }} height={25} width={25} fill='rgb(143, 155, 179)'/>
                <View style={{ flex: 1 }}>
                    <Text category='s1' style={{ fontWeight: 'bold' }}>{item.title}</Text>
                    <Text category='p1' appearance='hint'>{item.description}</Text>
                </View>
            </View>
        </BasicCard>
    );
    const listEmptyComponent = () => (
        <BasicCard style={{ marginBottom: 10, borderWidth: 0 }}>
            <NoSurveyCard
                subtitle={'No polls found'}
                hideButton
            />
        </BasicCard>

    );
    const keyExtractor = (item: CardItem) => item.id;


    return (
        <Layout level='1' style={{ flex: 1 }}>
            <FlatList
                data={data.surveys}
                renderItem={renderSurvey}
                keyExtractor={keyExtractor}
                ListHeaderComponent={renderHeader}
                ListFooterComponent={renderFooter}
                ListEmptyComponent={listEmptyComponent}
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : undefined}
            />
        </Layout>
    );
}
